module.exports = __webpack_public_path__ + "static/media/4.47cf05d0.png";